module.exports = __webpack_public_path__ + "img/map_bg.807299f4.png";